import React from 'react'

/**
 * Types and Interface
 */
import {
  HttpResponse,
  DefaultComponentProps,
}
from '@interface/common'

/**
 * Helpers
 */
import {pure} from '@react/store'
import string from '@helpers/string'
import {
  http,
  datetime,
}
from '@helpers/common'

/**
 * Components
 */
import TableBottom from '@components/table/bottom'

/**
 * Images
 */
import Spinner from '@assets/images/spinner.gif'


/**
 * Audit Log Screen
 */
export default pure(({store}: DefaultComponentProps) => {
  const state = store.useLocalState({
    logs: [],
    limit: 50,
    error: false,
    fetching: true,
    action: null,
  })

  /**
   * Fetch logs on mount
   */
  React.useEffect(() => {
    fetchLogs()
  }, [])


  /**
   * Get audit logs
   */
  function fetchLogs() {
    http.get(`/audit`, {
      query: {
        limit: state.limit,
        action: state.action,
      },
    })
    .then(({result}: HttpResponse) => {
      if(result) {
        state.set({logs: result, error: false, fetching: false})
      }
      else {
        state.set({logs: [], fetching: false})
      }
    })
    .catch((e: any) => {
      console.error(e)
      state.set({logs: [], fetching: false})
    })
    state.set({fetching: true})
  }


  return (
    <div className="inner">
      <header>
        <div className="left">
          <h3 className="margin-0">Audit Log</h3>
        </div>
        <div className="right filter">
          <span className="select">
            <label>Action</label>
            <select onChange={(e) => state.set({action: e.target.value})}>
              <option value="">All</option>
              <option value="block">Block</option>
              <option value="approve">Approve</option>
            </select>
          </span>
          <span onClick={() => fetchLogs()} className="button-3">Filter</span>
        </div>
      </header>
      <div className="table">
        <table>
          <thead>
            <tr>
              <th>Action</th>
              <th>Post</th>
              <th>Type</th>
              <th>Moderator</th>
              <th>Reported By</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {state.fetching ? (
              <tr>
                <td colSpan={6} style={{textAlign: 'center'}}>
                  <img alt={'Spinner'} src={Spinner} style={{width: 32, padding: 20}}/>
                </td>
              </tr>
            ):(
              <>
                {state.logs.length > 0 ? (
                  <>
                    {state.logs.map((item: any, key: number) => {
                      const date = datetime(item.created)

                      return (
                        <tr key={key}>
                          <td>
                            <span
                              style={{
                                padding: '4px 10px',
                                borderRadius: 4,
                                fontSize: 12,
                                fontWeight: 600,
                                color: item.action === 'block' ? '#d9534f' : '#5cb85c',
                                backgroundColor: item.action === 'block' ? '#fdf2f2' : '#f2fdf3',
                              }}>
                              {string.toUCFirst(item.action)}
                            </span>
                          </td>
                          <td style={{maxWidth: 300}}>
                            {item.post?.text ? string.ellipsis(item.post.text, 15) : (
                              <span style={{fontStyle: 'italic', color: '#bbb'}}>n/a</span>
                            )}
                          </td>
                          <td>{item.post?.type ? string.toUCFirst(item.post.type) : '—'}</td>
                          <td>{item.moderator || '—'}</td>
                          <td>
                            {item.reported?.reporter ? item.reported.reporter : (
                              <span style={{fontStyle: 'italic', color: '#999'}}>AI</span>
                            )}
                          </td>
                          <td style={{width: 250}}>{date.getDate()}</td>
                        </tr>
                      )
                    })}
                  </>
                ):(
                  <tr>
                    <td colSpan={6} style={{textAlign: 'center'}}>
                      <span>No Results</span>
                    </td>
                  </tr>
                )}
              </>
            )}
          </tbody>
        </table>
      </div>
      <TableBottom
        entries={{
          onChange(e) {}
        }}
        pagination={{
          limit: state.limit,
          total: state.total,
          onClick(selected) {},
          onPrev() {},
          onNext() {},
        }}
      />
    </div>
  )
})
